var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCircle48Filled = function SvgIconCircle48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.7c9.224 0 16.7-7.477 16.7-16.7 0-9.223-7.476-16.7-16.7-16.7-9.222 0-16.7 7.477-16.7 16.7 0 9.223 7.478 16.7 16.7 16.7Z",
    fill: "current"
  })));
};
export default SvgIconCircle48Filled;